<style scoped>
  .slot_section .row {
    display: flex;
    flex-wrap: nowrap;   /* keep same row */
    justify-content: space-between;
    gap: 10px !important;
  }

  /* Calendar and Slot box each take 50% */
  .custom-calendar,
  .slot-box {
    flex: 0 0 43%;
    max-width: 50%;
  }

  /* Make sure content fits well */
  .custom-calendar {
    background: #ffffff;
    padding: 15px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  .slot-box {
    border: 2px solid #f8d0d0;
    border-radius: 8px;
    background: #fff;
    padding: 20px;
  }

  /* Calendar sizing */
  #datepicker {
    width: 100%;
  }
  .flatpickr-calendar {
    width: 100% !important;
    max-width: 100% !important;
    box-shadow: none !important;
    background: transparent;
  }


  /* Unified Fix for Tablet & Small Desktop Overflow (600px–1366px) */
  @media screen and (min-width: 600px) and (max-width: 1366px) {
    .slot_section .row {
      flex-wrap: wrap !important;         /* allow wrapping */
      justify-content: center !important; /* center content */
      align-items: flex-start !important;
      overflow-x: hidden !important;
      gap: 20px !important;               /* consistent gap between boxes */
    }

    .custom-calendar,
    .slot-box {
      flex: 0 0 85% !important;           /* slightly wider for tablets */
      max-width: 100% !important;
      margin: 0 auto 20px auto !important; /* centers each block perfectly */
    }

    /*  Add calendar padding & height */
    .custom-calendar {
      padding: 55px !important;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      background: #ffffff;
      border-radius: 12px;
      min-height: 550px !important;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    /* Keep slot box aligned visually */
    .slot-box {
      padding: 25px !important;
      border: 2px solid #f8d0d0;
      border-radius: 8px;
    }

    /* Fix Flatpickr Month Header Visibility */
    .flatpickr-calendar {
      width: 100% !important;
      max-width: 100% !important;
      overflow: visible !important;
    }

    /*  Better Month Header Spacing for Flatpickr */
    .flatpickr-months {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      overflow: visible !important;
      font-size: 1.1rem !important;
      margin-bottom: 25px !important;  /* actual visual gap below month header */
    }

    .flatpickr-current-month {
      font-size: 1.2rem !important;
      text-align: center !important;
      padding: 8px 0 !important;       /* light internal spacing */
      line-height: 1.4 !important;
    }

    .flatpickr-prev-month,
    .flatpickr-next-month {
      top: 8px !important;
      transform: scale(0.9);
      padding: 5px !important;         /* small clickable area only */
    }

    .flatpickr-innerContainer {
      /* gap: 50% !important; */
      gap: 12px !important;
    }

  }



  /* Optional: prevent overflow on smaller screens */
  @media (max-width: 575px) {
    .slot_section .row {
      flex-wrap: wrap; /* stack only if too small */
    }
    .custom-calendar,
    .slot-box {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

  ::v-deep(.flatpickr-innerContainer) {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    flex-direction: column !important;
    margin: 0 auto !important;
    padding: 15px 0 !important;
  }

  ::v-deep(.flatpickr-days) {
    justify-content: center !important;
  }

  ::v-deep(.flatpickr-calendar) {
    margin: 0 auto !important;
    text-align: center !important;
  }
</style>


<style>
  .flatpickr-calendar {
    width: 100% !important;
    max-width: 100% !important;
    box-shadow: none !important;
    background: transparent;
  }
  /* --- Responsive Adjustments --- */
  /* Mobile <576px */
  /* --- FIX: Calendar Overflow on Mobile --- */
  @media (max-width: 575.98px) {
    /* Force horizontal scroll if calendar exceeds container width */
    .custom-calendar {
      overflow-x: auto !important;
      -webkit-overflow-scrolling: touch; /* smooth scroll on iOS */
      padding-bottom: 10px;
    }

    /* Wrap inner Flatpickr properly */
    .flatpickr-calendar {
      min-width: 360px !important; /* ensures calendar fits on narrow screens */
      display: inline-block !important;
    }

  }

  /* fix month dropdown spacing & layout */
  .flatpickr-monthDropdown-months {
    margin: 0 12px !important;          /* horizontal gap between arrows and year */
    padding: 6px 8px !important;        /* inner space for better visual balance */
    
    background-color: #fff !important;  /* ensure background is visible */
    font-size: 1rem !important;         /* adjust text size */
    width: auto !important;             /* prevent fixed width clipping */
    min-width: 100px !important;        /* optional — ensure readable width */
    appearance: none !important;        /* remove default browser arrow style */
  }

  /* optional — add small downward chevron style */
  .flatpickr-monthDropdown-months::-ms-expand {
    display: none;
  }

  /* align dropdown with arrows nicely */
  .flatpickr-months .flatpickr-month {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 8px !important;                /* adds clear gap */
    margin-bottom: 20px !important;     /* space below month section */
  }

  /* Center the entire calendar grid section */
  .flatpickr-innerContainer {
    display: flex !important;
    justify-content: center !important; /* horizontally center calendar */
    align-items: center !important;     /* vertically align (optional) */
    flex-direction: column !important;
    margin: 0 auto !important;
    padding: 15px 0 !important;
  }

  /* Optional: make the days grid more balanced */
  .flatpickr-days {
    display: flex !important;
    justify-content: center !important; /* center days grid too */
    align-items: center !important;
  }

  /* Optional — ensure it doesn’t stretch weirdly */
  .flatpickr-calendar {
    margin: 0 auto !important;
    text-align: center !important;
  }

  /* General Day Styling */
  .flatpickr-days .flatpickr-day {
    margin: 2.49px !important;
    padding: 0 !important;
    border-radius: 50% !important;
    font-weight: 500 !important;
    color: #333 !important;
  }

  /* Hover Effect */
  .flatpickr-day:hover {
    background-color: #ffeaea !important;
    color: #b80000 !important;
    transform: scale(1.05);
    box-shadow: 0 2px 6px rgba(255, 0, 0, 0.15);
  }

  /* Selected Day */
  .flatpickr-day.selected,
  .flatpickr-day.selected.today {
    background: linear-gradient(135deg, #ff4b4b, #d80000) !important;
    color: #fff !important;
    border-radius: 50% !important;
    border: none !important;
    font-weight: 600 !important;
    box-shadow: 0 3px 8px rgba(255, 0, 0, 0.3);
    transform: scale(1.1);
  }

  /* Highlighted (Special) Dates */
  .flatpickr-day.highlighted-date {
    background: linear-gradient(135deg, #ffb4b4, #fd8888) !important;
    color: #fff !important;
    border-radius: 50% !important;
    font-weight: 600 !important;
    box-shadow: 0 2px 6px rgba(253, 136, 136, 0.3);
  }

  /* Selected + Highlighted Combined */
  .flatpickr-day.highlighted-date.selected {
    background: linear-gradient(135deg, #f00e0e, #ab0e0e) !important;
    box-shadow: 0 3px 10px rgba(240, 0, 0, 0.4);
  }

  /* Optional: Adjust day cell size */
  .flatpickr-day,
  .flatpickr-day.selected,
  .flatpickr-day.highlighted-date {
    width: 2.4em !important;
    height: 2.4em !important;
    line-height: 2.4em !important;
  }

  /* Optional: today border for context */
  .flatpickr-day.today:not(.selected):not(.highlighted-date) {
    border: 1px dashed #d80000 !important;
    color: #d80000 !important;
    font-weight: 600 !important;
  }

</style>


<template>
    <div class="row">
        <div class="col-lg-3 d-none d-lg-block side_bar">
          <div class="sidebar-wrapper p-3">
    
            <!-- Appointment Summary -->
            <div v-if="sideBarApplicantData" class="appointment-summary mb-4">
              <h6 style="color: #C8102E;"><b>Appointment Details</b></h6>
              <ul class="list-unstyled mb-0">
                <li class="mb-2">
                  <strong>Booking ID:</strong> <span>{{ sideBarApplicantData.booking_no }}</span>
                </li>
                <li class="mb-2">
                  <strong>Applicant Name:</strong> <span>{{ sideBarApplicantData.applicant_name }}</span>
                </li>
              </ul>
            </div>

            <hr />

            <!-- Patient Info -->
            <div class="patient-info mb-4">
              <h6 style="color: #C8102E;"><b> Register Info</b></h6>
              <ul class="list-unstyled mb-0">
                 
                <li class="mb-2">
                  <strong>Name :</strong> <span>{{ sideBarApplicantData.name }}</span>
                </li>
                <li class="mb-2">
                  <strong>Email Address:</strong> <span>{{ sideBarApplicantData.email }}</span>
                </li>
                <li class="mb-2">
                  <strong>Phone Number:</strong> <span>{{ sideBarApplicantData.phoneNumber }}</span>
                </li>

              </ul>
            </div>

            <hr />

            <!-- Help / Instruction -->
            <div class="reschedule-help">
              <h6 style="color: #C8102E;"><b>How to Reschedule</b></h6>
              <ul class="ps-3">
                <li>Select your preferred date from the calendar.</li>
                <li>Choose an available slot that suits you.</li>
                <li>Click <strong>Reschedule</strong> to confirm.</li>
              </ul>
              <!-- <p class="mt-3 small text-muted">
                <i class="bi bi-exclamation-triangle me-1"></i>
                Rescheduling is allowed only once per booking.
              </p> -->
            </div>

          </div>
        </div>

        <div class="col-12 col-lg-9 form-section p-lg-5 p-4">
            <div class="container slot_section">
            <h5> Select And Reschedule Single Slot</h5>
            <p>Available Slot on {{ formattedDate }}</p>

            <div class="row g-3">
            
                <div class="col-md-5 custom-calendar ">
                  <label class="form-label fw-bold">
                      <i class="bi bi-calendar-check"></i> Preferred Appointment Date
                  </label>
                  <div id="datepicker" class="highlighted-date"></div>
                </div>

                <div class="col-md-6 ps-lg-5 slot-box">
                  <h6 class="my-4 mt-lg-0">{{ formattedDate }}</h6>
                  <div class="slot-container mt-3">
                      <button
                      v-for="(slot, index) in slots"
                      :key="slot.id"
                      class="slot-button"
                      :class="{ active: selectedSlot === index }"
                      @click="selectSlot(index)"
                      :disabled="selectedNoOfChildren > 0 && slot.child === false"
                      >
                      {{ slot.start_time }} - {{ slot.end_time }}
                      <span class="badge">{{ slot.available_slot_count }} Slot Available</span>
                      </button>
                  </div>
                  <span v-if="errors.selectedSlot" class="text-danger">{{ errors.selectedSlot }}</span>
                  <div v-if="slots.length === 0" class="no-appointments-message">
                      <p>No appointment times available for the selected date.</p>
                  </div>
                </div>
            </div>

            <!-- Continue Button -->
            <div class="row mt-lg-5 pt-lg-5 my-4 pt-4">
                <div class="col-12 text-center">
                <button class="btn continue-btn w-50 px-4 py-2" :disabled="loading" @click="handleContinue" >
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {{ loading == true ? 'Processing...' : 'Reschedule' }}
                </button>
                </div>
            </div>
            </div>
        </div>
    </div>
   
  <div id="preloader" v-if="entirePageLoading" style="position: fixed; top:0; left:0; width:100%; height:100%; background: rgba(255,255,255,0.8); z-index: 9999; display:flex; flex-direction:column; justify-content:center; align-items:center;">
    <img src="@/assets/Images/Logo/preloader.png" alt="Loading Image" style="width:100px;">
    <p>Loading...</p>
  </div>
</template>
<script>
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { SlotsPediatricFriendly, SlotsByDate } from "@/api/Post/slot";
import { ResheduleSingleBookings } from "@/api/Post/track";
import { LogoutPage } from "@/api/Post/action";
import Swal from 'sweetalert2';
export default {
    name: "resheduleSingleBooking",
    props: {
      booking: {
        type: Object,
        required: true
      }
    },
    data() {
        return {
            selectedDate: new Date(),
            selectedDateFormatted: "",
            selectedSlot: null,
            highlightedDates: [],
            slots: [],
            selectedNoOfChildren: 0,
            country_entity_id: null,
            errors: {},
            loading: false,
            entirePageLoading: false,
            booking_id: '',
            applicant_id: '',
            sideBarApplicantData: {
              booking_no: '',
              phoneNumber: '',
              name: '',
              email: '',
              applicant_name: ''
            },
        };
    },
    computed: {
        formattedDate() {
            return this.selectedDate
            ? this.selectedDate.toLocaleDateString("en-US", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
            })
            : "";
        },
    },
    mounted() {
        const resheduleApplicantData = localStorage.getItem('resheduleApplicantData');
        ///console.log('resheduleApplicantData :', JSON.stringify(resheduleApplicantData, null, 2));
        if (resheduleApplicantData) {
          try {
            this.sideBarApplicantData = JSON.parse(resheduleApplicantData);
            //console.log('resheduleApplicantData:1', JSON.stringify(this.sideBarApplicantData, null, 2));
          } catch (error) {
            //console.error('Error parsing resheduleApplicantData:', error);
            Swal.fire({
              title: 'Invalid Data',
              text: 'Reschedule applicant data is corrupted.',
              confirmButtonText: 'OK'
            });
          }
        } else {
          //console.warn('No resheduleApplicantData found in localStorage');
          Swal.fire({
            title: 'No Data Found',
            text: 'Reschedule applicant data not found. Please try again.',
            confirmButtonText: 'OK'
          });
        }
        this.selectedNoOfChildren = this.booking.childs;
        this.country_entity_id = this.booking.slot.entity_id;
        this.booking_id = this.booking.id;
        this.fetchSlotsDates().then(() => {
        this.initFlatpickr(); 
        //this.fetchSlots();
        });
    },
    methods: {
    initFlatpickr() {
      const self = this;

      flatpickr("#datepicker", {
        inline: true,
        dateFormat: "Y-m-d",
        defaultDate: self.selectedDate,
        minDate: "today",
        onChange(selectedDates, dateStr) {
          self.selectedDate = selectedDates[0];
          self.selectedDateFormatted = dateStr;
          self.fetchSlots();
        },
        onDayCreate(dObj, dStr, fp, dayElem) {
          if (!self.highlightedDates || !Array.isArray(self.highlightedDates)) return;

          const year = dayElem.dateObj.getFullYear();
          const month = String(dayElem.dateObj.getMonth() + 1).padStart(2, '0');
          const day = String(dayElem.dateObj.getDate()).padStart(2, '0');
          const dateStr = `${year}-${month}-${day}`; // local time

          const isHighlighted = self.highlightedDates.includes(dateStr);
          if (isHighlighted) {
            dayElem.classList.add("highlighted-date");
          }
        },

        onReady(selectedDates, dateStr) { 
          self.selectedDate = selectedDates[0];
          self.selectedDateFormatted = dateStr;
          self.fetchSlots();
        },
      });
    },


    async fetchSlotsDates() {
      this.entirePageLoading = true;
      
      try {
        const entiti_id = this.$route.params.id;
        const year = new Date().getFullYear();
        //console.log('this.selectedNoOfChildren:', this.selectedNoOfChildren);
        const hasChildren = this.selectedNoOfChildren ? "true" : "false";
        const response = await SlotsPediatricFriendly(hasChildren, this.country_entity_id, year);
        ///this.highlightedDates = response.data.data.date || [];

        this.highlightedDates.splice(0); // clears the array
        this.highlightedDates.push(...(response.data.data.date || []));

        if (this.highlightedDates.length > 0) {
          const firstDate = this.highlightedDates[0];
          this.selectedDate = new Date(firstDate);
          ///console.log('highlightedDates:', this.highlightedDates);
          ////console.log('firstDate:', firstDate);
          this.selectedDateFormatted = firstDate;
        }

        //await new Promise(resolve => setTimeout(resolve, 200));
      } catch (error) {
        //console.error("Error fetching slots dates:", error);
      } finally {
        this.entirePageLoading = false;
      }
    },

    selectSlot(index) {
      this.selectedSlot = index;
      ////console.log("this.selectedSlot:", this.slots[index]);
      localStorage.setItem("selectedSlot", JSON.stringify(this.slots[index]));
    },



    async fetchSlots() {
      try {
        if (!this.selectedDateFormatted) return;

        const entiti_id = this.$route.params.id;
        const year = new Date().getFullYear();
        //console.log('this.selectedNoOfChildren:', this.selectedNoOfChildren);
        const hasChildren = this.selectedNoOfChildren ? "true" : "false";
        const response = await SlotsByDate(hasChildren, this.country_entity_id, this.selectedDateFormatted);

        if (response.data && Array.isArray(response.data.data)) {
          this.slots = response.data.data.map(slot => ({
            id: slot.id,
            start_time: this.formatTime(slot.start_time),
            start_Date: slot.start_time,
            end_time: this.formatTime(slot.end_time),
            end_Date: slot.end_time,
            available_slot_count: slot.available_slot_count,
            slot_price: slot.slot_price,
            entity_price: slot.entity_price,
            entity_custom_text: slot.entity_custom_text,
            is_break: slot.is_break,
            booking_full: slot.booking_full,
            booking_closed: slot.booking_closed,
            child: slot.child,
          }));
        
        } else {
          this.slots = [];
        }
      } catch (error) {
        console.error("Error fetching slots:", error);
        this.slots = [];
      }
    },

    formatTime(time) {
      const date = new Date(time);
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';
      const formattedHours = hours % 12 || 12;
      const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
      return `${formattedHours}:${formattedMinutes} ${ampm}`;
    },

   
    async handleContinue() {
      this.errors.selectedSlot = null;
      this.loading = true;
      //await new Promise(resolve => setTimeout(resolve, 400));

      if (this.selectedSlot === null) {
        this.errors.selectedSlot = "Please select a slot before continuing.";
        this.loading = false;
        return;
      }
      ///console.log("this.selectedSlot:", this.selectedSlot);

      const selectedSlotData = this.slots[this.selectedSlot];

      ////console.log("selectedSlotData:", selectedSlotData);

      if (
        this.selectedNoOfChildren > 0 &&
        selectedSlotData &&
        selectedSlotData.child === false
      ) {
        this.errors.selectedSlot =
          "This slot is not available for children. Please select a child-friendly slot.";
          this.loading = false;
        return;
      }


      const applicantId = localStorage.getItem('applicant_id');
      ///console.log('applicantId: hai : :', applicantId);

        return ResheduleSingleBookings(applicantId, this.booking_id, selectedSlotData.id)
              .then((cancelResponse) => {
                const cancelRes = cancelResponse.data;
                ///console.log("Reschedule Response:", cancelRes);
                if (cancelRes.success) {
                  Swal.fire({
                    title: cancelRes.message || 'Bookings Rescheduled successfully.',
                    text: `New Booking Number: ${cancelRes.details.booking_no}`,
                    showConfirmButton: true,
                    confirmButtonText: '<i class="fa fa-home"></i> Home',
                    confirmButtonColor: '#dc3545',
                    allowOutsideClick: false,
                    allowEscapeKey: false,  
                    allowEnterKey: true,
                    showClass: {
                      popup: 'animate__animated animate__fadeInDown'
                    },
                    hideClass: {
                      popup: 'animate__animated animate__fadeOutUp'
                    }
                  }).then((result) => {
                      if (result.isConfirmed) {
                          // Redirect to the details page after confirmation
                          //window.location.href = '/track/track-view-details';

                            LogoutPage()
                              .then(() => {
                                localStorage.removeItem('authToken');
                                this.$router.push({ name: 'trackAppointment' });
                              })
                              .catch((error) => {
                                //console.error("Logout Error:", error);

                                Swal.fire({
                                  title: 'Logout failed. Please try again.',
                                  showConfirmButton: false,
                                  timer: 3000,
                                  timerProgressBar: true,
                                  showClass: {
                                    popup: 'animate__animated animate__shakeX'
                                  },
                                  hideClass: {
                                    popup: 'animate__animated animate__fadeOutUp'
                                  }
                                });
                              });
                      }
                  });

                  // setTimeout(() => {
                  //   LogoutPage()
                  //     .then(() => {
                  //       localStorage.removeItem('authToken');
                  //       this.$router.push({ name: 'trackAppointment' });
                  //     })
                  //     .catch((error) => {
                  //       console.error("Logout Error:", error);

                  //       Swal.fire({
                  //         title: 'Logout failed. Please try again.',
                  //         showConfirmButton: false,
                  //         timer: 3000,
                  //         timerProgressBar: true,
                  //         showClass: {
                  //           popup: 'animate__animated animate__shakeX'
                  //         },
                  //         hideClass: {
                  //           popup: 'animate__animated animate__fadeOutUp'
                  //         }
                  //       });
                  //     });

                  //   window.location.href = '/track/track-view-details';
                  // }, 2000);
                  
                } else {
                    this.loading = false;
                    this.$toast.error(cancelRes.message || 'Failed to Reschedule bookings.', {
                      position: 'top-right',
                      duration: 3000,
                    });
                }
              })
              .catch((error) => {
                this.loading = false;
                this.$toast.error('Failed to Reschedule bookings. Please try again.', {
                  position: 'top-right',
                  duration: 3000,
                });
              })
              .finally(() => {
                // const modalEl = document.getElementById('otpModal');
                // if (modalEl) {
                //   const otpModal = bootstrap.Modal.getInstance(modalEl);
                //   if (otpModal) otpModal.hide();
                // }
                this.loading = false;
               ////console.log("rescheduled success.");
              });

    }

    
  },
    
}
</script>